"use strict";

define('rs/models/document.letter',['rs/models/abstract', 'rs/models/letter'], function (RSAbstractModel, Letter) {
  var DocumentLetter = RSAbstractModel.extend({
    properties: ['decision', 'document', 'letterTemplate'],
    serverProperties: ['activityDate', 'bcc', 'cc', 'content', 'dateSent', 'id', 'recipients', 'sentBy', 'subject', 'updateUserAuthId', 'version'],
    sync: function sync() {
      var that = this;
      if (this.id) {
        return this.constructor.requestUpdate(this.id, this).then(function (data) {
          return that.applyProperties(_.pick(data, that.serverProperties));
        });
      }
      return this.constructor.requestCreate(this);
    },
    requestDelete: function requestDelete() {
      return this.constructor.requestDelete(this.getId());
    },
    requestCurrentContent: function requestCurrentContent(documentId) {
      if (this.dateSent != null) {
        return Promise.resolve(this.contentSent || '');
      }
      return this.constructor.requestReplace(documentId, this.content);
    },
    toJSON: function toJSON() {
      var json = this._super.apply(this, arguments),
        decision = this.getDecision(),
        doc = this.getDocument(),
        letterTemplate = this.getLetterTemplate();
      json.document = doc ? _.pick(doc, 'id') : undefined;
      json.decision = decision ? _.pick(decision, 'id') : undefined;
      json.letterTemplate = letterTemplate ? _.pick(letterTemplate, 'id') : undefined;
      return json;
    }
  }, {
    rootURI: '/rs/api/',
    parsers: {
      '#get#documentLetter/:id': function getDocumentLetter_Id(data) {
        return DocumentLetter.model(data);
      },
      '#GET#documentLetter/document/:documentId': function GETDocumentLetter_document_DocumentId(data) {
        return DocumentLetter.models(data);
      },
      'documentLetter/decision/:decisionId': function documentLetter_decision_DecisionId(data) {
        return DocumentLetter.models(data);
      }
    },
    requestOne: function requestOne(id) {
      return this.get('documentLetter/' + id);
    },
    requestReplacedLetterContent: function requestReplacedLetterContent(documentLetterId) {
      var that = this;
      return this.requestOne(documentLetterId).then(function (documentLetter) {
        var doc = documentLetter.getDocument();
        return doc ? that.requestReplace(doc.id, documentLetter.content) : '';
      });
    },
    requestCreate: function requestCreate(data) {
      return this.post('documentLetter', data, {
        jsonBody: true
      });
    },
    requestUpdate: function requestUpdate(id, data) {
      return this.put('documentLetter/' + id, data, {
        jsonBody: true
      });
    },
    requestDelete: function requestDelete(id) {
      return this.del('documentLetter/' + id);
    },
    requestAllByDocumentId: function requestAllByDocumentId(documentId) {
      return this.get('documentLetter/document/' + documentId);
    },
    requestAllByDecisionId: function requestAllByDecisionId(decisionId) {
      return this.get('documentLetter/decision/' + decisionId);
    },
    requestPopulatedTemplate: function requestPopulatedTemplate(templateId, documentId) {
      return Letter.requestLoadById(templateId).then(function (letter) {
        return letter.content;
      });
    },
    requestReplace: function requestReplace(documentId, text) {
      return this.post('letter/replace/' + documentId, {
        text: text
      }, {
        jsonBody: true
      });
    }
  });
  return DocumentLetter;
});

